import { useBatchConfigurationDetails } from './useBatchConfigurationDetails';

export const useEditBatchConfiguration = (batchId: string) => {
  const {
    batchConfigurationDetails,
    isBatchConfigurationDetailsLoading,
    batchConfigurationDetailsError,
    refetchBatchConfigurationDetails,
  } = useBatchConfigurationDetails(batchId);

  return {
    isLoadingFormDetails: isBatchConfigurationDetailsLoading,
    batchConfigurationDetailsError,
    batchConfigurationDetails,
    refetchBatchConfigurationDetails,
  };
};
